import React from "react";
import { Box } from "@mui/material";
import ProfileCard from "./ProfileCard";

const Fsn193MyProfile = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100vw", // Full viewport width
        height: "100vh", // Full viewport height
        overflowY: "auto", // Enables scrolling for the full container
        backgroundColor: "#f5f5f5", // Optional: background color
      }}
    >
      {/* Full Scrollable Content */}
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* Profile Card */}
        <ProfileCard />

        {/* Iframe Section */}
        <Box
          sx={{
            width: "100%", // Full width
            height: "100vh", // Full viewport height
            mt: 0, // Removes unnecessary top margin
          }}
        >
          <iframe
            src={
              "https://.goqii.com"
            }
            title="Web Card"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Fsn193MyProfile;